const tools = [
  'развивающие задачи;',
  'делегирование;',
  'совместный разбор ситуаций;',
  'наблюдение за работой;',
  'обратная связь;',
  'разбор ошибок;',
  'наставничество;',
  'обучение на рабочих кейсах;',
  'участие в проектах;',
  'временное расширение зоны ответственности;',
  'передача части функций;',
  'участие в принятии решений.',
];

export default function DevelopThroughWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Развитие происходит не только на обучении
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Устойчивое развитие сотрудника невозможно только через тренинги. Инструменты развития встроены в саму работу:
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto mb-12">
          {tools.map((t, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{t}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed font-semibold text-center">
            Развитие сотрудника становится эффективнее, когда происходит непосредственно в рабочем процессе.
          </p>
        </div>
      </div>
    </section>
  );
}